/**
 * Keys that always pass through the date field's keydown handler without being
 * blocked, regardless of whether they produce a printable character.
 * Covers navigation, editing, and control keys that don't affect date content.
 */
export const DATE_FIELD_PASSTHROUGH_KEYS = new Set([
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Tab',
  'Enter',
  'Home',
  'End',
]);
